import apiClient from './apiClient'
import { vinDecode } from './apiEndpoints'
import { log } from '@/utils/logger'
import type { ApiEnvelope } from '@/types/api'

export async function decodeVin(vin: string): Promise<ApiEnvelope<unknown>> {
  log.info('decodeVin', { vin })
  try {
    const { data } = await apiClient.get<ApiEnvelope<unknown>>(vinDecode(vin))
    log.info('decodeVin success', { vin, success: String(data.success) })
    return data
  } catch (err) {
    log.error('decodeVin failed', err instanceof Error ? err : new Error(String(err)), { vin })
    throw err
  }
}
